import React, {useEffect, useRef, useState} from 'react';

import {useLocation, Link} from 'react-router-dom';

import H5AudioPlayer from 'react-h5-audio-player';
import {useModule} from '@/hooks/useModule';
import {useSubject} from 'springboard/module_registry/module_registry';

import '@/styles/audio_player.scss';

// import {FileInfo} from 'springboard/modules/files/file_types';
// import {StateSupervisor} from 'springboard/services/states/shared_state_service';
// import {WaveformModern} from './waveform_modern';
// // import {WavesurferReact} from './wavesurfer_react';
// import {WavesurferWithHook} from './wavesurfer_with_hook';
// import {StoredFileMeta} from '@/modules/files/files_module';
import {DBObjects} from '@/store/store_types';

import {IconMessage2} from '@tabler/icons-react';
import {useIsMobile} from '@/utils/user_agent';
import {useSignals} from '@preact/signals-react/runtime';
import {signalCommentTextareaIsFocused} from '@/modules/music_sniper/components/comments/comment_form';
import {signal} from '@preact/signals-react';

export const signalAudioSrc = signal('');

type Props = {
    // fileInfoStateSupervisor: StateSupervisor<DBObjects['File'] | null>   ;
    fileInfo: DBObjects['File'] | null;
    getFileSrc: (file: DBObjects['File']) => Promise<string>;
    bottomNav?: boolean;

    onPlaying: () => void;
    onPause: () => void;

    // mostRecentAutomatedSeek: {seekTime: number} | null;
};

export const AudioPlayer = (props: Props) => {
    useSignals();

    const lastSrcRefresh = useRef<Date | null>(null);

    const audioElementRef = useRef<H5AudioPlayer>(null);
    // const audioElementRef = useRef<HTMLAudioElement>(null);

    const audioPlayerModule = useModule('AudioPlayer');
    const mostRecentAutomatedSeek = useSubject(null, audioPlayerModule.mostRecentAutomatedSeek);

    const [audioSrc, setAudioSrc] = useState('');
    useEffect(() => {
        if (audioSrc !== signalAudioSrc.value) {
            signalAudioSrc.value = audioSrc;
        }
    }, [audioSrc]);

    const [playing, setPlaying] = useState(false);
    const [nonce, setNonce] = useState('');

    const fileInfo = props.fileInfo;

    const loc = useLocation();
    const isOnSpecificFilePage = Boolean(fileInfo && loc.pathname.includes(fileInfo.id));

    const [hidePlayer, setHidePlayer] = useState(false);

    // useEffect(() => {
    //     if (isOnSpecificFilePage) {
    //         // setHidePlayer(true);
    //     } else {
    //         setHidePlayer(false);
    //     }
    // }, [isOnSpecificFilePage]);

    const [audioPlayerTopPosition, setAudioPlayerTopPosition] = useState<number | null>(null);

    useEffect(() => {
        const adjustFooterContentPosition = async () => {
            if (!isOnSpecificFilePage) {
                return;
            }

            let textarea = document.getElementById('comment-textarea')!;
            if (!textarea) {
                await new Promise(r => setTimeout(r, 1000));
                textarea = document.getElementById('comment-textarea')!;
                if (!textarea) {
                    return;
                }
            }

            const rect = textarea.getBoundingClientRect();

            const footerContentHeight = 100;

            if (window.scrollY - rect.top > 100) {
                setAudioPlayerTopPosition(null);
            } else {
                const newPosition = 269.4375 - footerContentHeight;
                setAudioPlayerTopPosition(newPosition);
            }
        };

        window.addEventListener('scroll', adjustFooterContentPosition);
        window.addEventListener('resize', adjustFooterContentPosition);

        adjustFooterContentPosition();

        return () => {
            window.removeEventListener('scroll', adjustFooterContentPosition);
            window.removeEventListener('resize', adjustFooterContentPosition);
        };
    }, [isOnSpecificFilePage]);

    const triggerFileSrc = async (file: NonNullable<typeof fileInfo>) => {
        const src = await props.getFileSrc(file);
        setAudioSrc(src);
        // if (nonce) { // this was here to make it so if `props.fileInfo` is defined on startup, we don't start playing the song. nonce is empty on startup
        setPlaying(true);
        // }
        setNonce(Math.random().toString().slice(2));
    };

    useEffect(() => {
        if (fileInfo) {
            triggerFileSrc(fileInfo);
        }
    }, [fileInfo]);

    useEffect(() => {
        if (mostRecentAutomatedSeek && audioElementRef.current?.audio.current) {
            if (!isNaN(mostRecentAutomatedSeek.seekTime)) {
                audioElementRef.current.audio.current.currentTime = mostRecentAutomatedSeek.seekTime;
            }
        }
    }, [mostRecentAutomatedSeek]);

    (window as any).togglePlayPause = () => {
        audioElementRef.current?.togglePlay({stopPropagation: () => { }} as any);
    };

    (window as any).audioElement = audioElementRef.current?.audio.current;

    const isMobile = useIsMobile();

    const commentTextareaIsFocused = signalCommentTextareaIsFocused.value;
    const [audioPlayerHasFocusDuringComment, setAudioPlayerHasFocusDuringComment] = useState(false);

    const [queueAudioPlayerMove, setQueueAudioPlayerMove] = useState(false);

    // const shouldMoveAudioPlayer = isMobile && isOnSpecificFilePage;
    const shouldMoveAudioPlayer = isMobile && isOnSpecificFilePage && (audioPlayerHasFocusDuringComment || queueAudioPlayerMove); // || commentTextareaIsFocused);

    useEffect(() => {
        if (commentTextareaIsFocused) {
            setQueueAudioPlayerMove(true);
        } else {
            setQueueAudioPlayerMove(false);
        }
    }, [commentTextareaIsFocused]);

    return (
        <div
            style={{height: '100%', width: '100%'}}
            onClick={() => {
                // setHidePlayer(false); // TODO: need an obvious show/hide icon instead of this "touch anywhere" solution
            }}
        >
            {audioSrc && (
                <>
                    {/* <WavesurferWithHook
                        src={audioSrc}
                    /> */}
                    {/* <Player
                        src={audioSrc}
                    />
                    <WaveformModern
                        src={audioSrc}
                    />

                    <WavesurferReact
                        src={audioSrc}
                    /> */}

                    <div
                        className={props.bottomNav ? 'bottom-nav' : ''}
                        style={{
                            overscrollBehavior: 'none',
                            touchAction: 'none',          // Disable touch scrolling and gestures
                            userSelect: 'none',
                            display: hidePlayer ? 'none' : undefined,
                            position: 'fixed',
                            transition: 'top 2s ease 0s',
                            // top: shouldMoveAudioPlayer ? `${audioPlayerTopPosition}px` : undefined,
                            // transform: true || (audioPlayerHasFocus || signalCommentTextareaIsFocused.value) ? 'translateY(-360px)' : undefined,
                            width: '100%',
                            zIndex: 600,
                        }}
                        onFocusCapture={() => {
                            if (signalCommentTextareaIsFocused.peek()) {
                                setAudioPlayerHasFocusDuringComment(true);
                            }
                        }}
                        onBlurCapture={() => {
                            setAudioPlayerHasFocusDuringComment(false);
                        }}
                    >
                        {/* {
                        fileInfo && (
                            <span>
                                {fileInfo.name.substring(0, 10)}
                            </span>
                        )
                    } */}
                        {/* <audio
                            ref={audioElementRef}
                            style={{width: '800px'}}
                            key={nonce}
                            controls
                            autoPlay={playing}
                        >
                            <source src={audioSrc} type="audio/mpeg" />
                            Your browser does not support the audio tag.
                        </audio> */}
                        <H5AudioPlayer
                            onError={async e => {
                                if (!fileInfo) {
                                    return;
                                }

                                const now = new Date();
                                if (lastSrcRefresh.current) {
                                    if ((now.getTime() - lastSrcRefresh.current.getTime()) < 5000) {
                                        return;
                                    }
                                }

                                lastSrcRefresh.current = now;
                                triggerFileSrc(fileInfo);
                            }}
                            ref={audioElementRef}
                            autoPlay={false}
                            // autoPlay={playing}
                            src={audioSrc}
                            onPlaying={e => {
                                props.onPlaying();
                                (window as any).audioElement = audioElementRef.current?.audio.current;
                            }}
                            onLoadStart={() => {
                                const el = audioElementRef.current?.audio.current;
                                if (el?.pause && playing) {
                                    el.play();
                                };
                            }}

                            onPause={e => props.onPause()}
                            onSeeked={e => {
                                setTimeout(() => {
                                    const el = audioElementRef.current?.audio.current;
                                    if (el?.paused) {
                                        el.play();
                                    }
                                }, 10);
                            }}
                            customIcons={{
                                // forward: <IconRewindForward5/>,
                                // rewind: <IconRewindBackward5/>,
                                // previous: <IconArrowLeft/>,
                                next: <></>,
                            }}
                            onClickPrevious={() => {
                                const audioElement = audioElementRef.current?.audio.current
                                if (audioElement) {
                                    audioElement.currentTime = 0;
                                }
                            }}

                            customVolumeControls={[]}
                            customAdditionalControls={[
                                <Link
                                    to={`/workspaces/${props.fileInfo?.workspace_id}/files/${props.fileInfo?.id}`}
                                    style={{
                                        position: 'absolute',
                                        textDecoration: 'none',
                                        color: 'var(--mantine-text-color)'
                                    }}
                                >
                                    {isMobile ? (
                                        !isOnSpecificFilePage && (
                                            <div>
                                                <div>
                                                    {`${props.fileInfo?.name.substring(0, 5)}...`}
                                                </div>
                                                <div>
                                                    <IconMessage2
                                                        size={20}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    ) : (
                                        <>
                                            {props.fileInfo?.name}
                                            {' '}
                                            <IconMessage2
                                                size={12}
                                            />
                                        </>
                                    )}
                                </Link>
                            ]}
                            showSkipControls={true}
                        />
                    </div>
                </>
            )}
        </div>
    );
}
